import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { Link } from "react-router-dom";
import { fontNormal } from "@fdr/static-ui/Typography";
import { DerbyEventStatus } from "@fdr/types/ts/Derby";
import { FooterLinkTypes, HomeHeaderFooterLinkProp } from "./types";

export const Container = styled.div<{
  raceStatus: DerbyEventStatus;
  showDerbyPicks?: boolean;
}>`
  ${({ raceStatus, showDerbyPicks }) =>
    raceStatus === DerbyEventStatus.DERBY_DAY &&
    css`
      ${showDerbyPicks
        ? css`
            background-color: ${buildColor("white", "100")};
          `
        : `background-color: ${buildColor("blue", "950")}`};
    `}
  ${({ raceStatus }) =>
    raceStatus === DerbyEventStatus.POST &&
    css`
      background-color: ${buildColor("navy", "700")};
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: ${buildColor("white", "100")};
    `}

   ${({ raceStatus }) =>
    raceStatus === DerbyEventStatus.PRE &&
    css`
      background-color: ${buildColor("blue", "950")};
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: ${buildColor("white", "100")};
    `}
      
    

  padding: 0 16px 12px 16px;
  display: flex;
  width: 100%;

  .derby-footer-info {
    margin-bottom: 12px;
    color: ${buildColor("white", "60")};
  }
`;

export const QuickLinksWrapper = styled.div`
  width: 100%;
  & > * {
    background-color: ${buildColor("navy", "700")};
  }
  ul > li:first-child {
    padding-left: 0;
  }
  ul > li:last-child {
    padding-right: 0;
  }
`;

const getDerbyLinkStyles = (type?: FooterLinkTypes) => {
  switch (type) {
    case FooterLinkTypes.BET:
      return css`
        background: linear-gradient(180deg, #32b964 0%, #189f4a 100%);
        color: ${buildColor("white", "100")};
      `;
    case FooterLinkTypes.LEARN:
      return css`
        background: linear-gradient(180deg, #1493ff 0%, #1381e0 100%);
        color: ${buildColor("white", "100")};
      `;
    default:
      return "";
  }
};

export const HomeHeaderFooterLink = styled(Link)<HomeHeaderFooterLinkProp>`
  height: 34px;
  width: 100%;
  border-radius: 4px;
  text-decoration: none;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${fontNormal};
  ${({ type }) => getDerbyLinkStyles(type as unknown as FooterLinkTypes)}
`;

export const DerbyLinks = styled.div`
  display: flex;
  width: 100%;
`;
